import { API_ROUTE } from "../../utils/constants.js";
import { baseApi } from "./baseApi.js";
import { getAuthToken, getToken } from "./localStorageService.js";

export const userAuthApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.login,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    forgotPassword: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.forgotPassword,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    forgotOtp: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.forgot_Otp,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    setNewPassword: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.setNewPassword,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            "authorization" : getAuthToken()
          },
        };
      },
      // keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    uploadAttachment: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.uploadAttachment,
          method: "POST",
          body: user,
          headers: {
            "authorization" : getToken()
          },
          formData: true,
        };
      },
    }),
    updateProfile: builder.mutation({
      query: (user) => {
        return {
          url: `/api/user`,
          method: "PATCH",
          body: user,
          headers: {
            "authorization" : getToken()
          },
        };
      },
    }),
    getNotifications: builder.query({
      query: () => {
        return {
          url: `/api/user/notifications`,
          method: "GET",
          headers: {
            "authorization" : getToken()
          },
        };
      },
    }),
  }),
});

export const {
  useLoginUserMutation,
  useForgotPasswordMutation,
  useForgotOtpMutation,
  useSetNewPasswordMutation,
  useUploadAttachmentMutation,
  useUpdateProfileMutation,
  useGetNotificationsQuery,
} = userAuthApi;
